export default __webpack_public_path__ + "static/media/image-sx.71628b02.png";